// @flow
import { handleResponseOld, makePost } from './helpers';

type PostPlaceAbsenteeBidParams = {
    authToken: string,
    deployment: string,
    details: any,
};

export const postPlaceAbsenteeBid = ({ authToken, deployment, details }: PostPlaceAbsenteeBidParams) => {
    return new Promise<any>((resolve, reject) => {
        const request = makePost({ authToken, deployment, path: '<MAINHOST-API>api/abs_bid' });
        request.type('form');
        request.send({
            accept_terms: true,
            bid: details.bidAmount,
            cat_id: details.catalogId,
            client: details.client,
            device_type: details.deviceType,
            lot_id: details.itemId,
        });
        request.end((err, response) =>
            handleResponseOld({
                err,
                reject,
                resolve,
                response,
                transform: body => ({
                    currentBid: body.current_bid,
                    isCurrentHighBid: body.is_current_high_bid,
                    isReserveMet: body.is_reserve_met,
                    leadingBid: body.leading_bid,
                    success: body.success,
                }),
            }),
        );
    });
};

type PostRetractBidParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
    itemId: number,
    retractionExplanation: any,
    retractionReason: any,
};

export const postRetractBid = ({
    authToken,
    bidderId,
    deployment,
    itemId,
    retractionExplanation,
    retractionReason,
}: PostRetractBidParams) => {
    return new Promise<any>((resolve, reject) => {
        const request = makePost({
            authToken,
            deployment,
            path: `<MAINHOST-API>api/bidders/${bidderId}/biditems/${itemId}/retract`,
        });
        request.send({
            retractionExplanation,
            retractionReason,
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
};
